import { useNavigate } from "flemo";
import { ChevronRightIcon, CrownIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { UserAvatar } from "@/components/UserAvatar";
import { useIsPlusQuery } from "@/hooks/queries";
import { fadeTransition } from "@/lib/transitions";
import { selectAvatarUrl, selectDisplayName, useAuthStore } from "@/store/authStore";

export function ProfileSection() {
  const { push } = useNavigate();
  const email = useAuthStore(state => state.user?.email) ?? "";
  const displayName = useAuthStore(selectDisplayName);
  const photoURL = useAuthStore(selectAvatarUrl);
  const { data: isPlus = false } = useIsPlusQuery();

  return (
    <section className="rounded-xl bg-card">
      {/* 유저 프로필 이미지 */}
      <Button
        type="button"
        variant="ghost"
        className="flex w-full items-center gap-4 py-10 px-4 hover:bg-muted/50 transition-colors border-0"
        onClick={() => push("/settings/profile", {}, { transitionName: fadeTransition.name })}
      >
        <UserAvatar src={photoURL} alt={displayName} className="size-12 shrink-0" />

        {/* 유저 정보 */}
        <div className="flex flex-col min-w-0 flex-1 text-left">
          <div className="flex items-center gap-1.5">
            <span className="text-sm font-semibold truncate">{displayName}</span>
            {isPlus && (
              <Badge className="gap-0.5 bg-primary/15 text-primary border-0 px-1.5 py-0">
                <CrownIcon className="size-2.5" />
                Plus
              </Badge>
            )}
          </div>
          {email && <span className="text-xs text-muted-foreground truncate">{email}</span>}
        </div>

        <ChevronRightIcon className="size-4 text-muted-foreground shrink-0" />
      </Button>
    </section>
  );
}
